import styled, { css } from 'styled-components'
import { Field, ErrorMessage } from 'formik'
import media from 'css-in-js-media'
import { Variables } from '../styles/Variables'
import React from 'react'
import { CheckboxContainer } from './Checkbox'

export const ValidationError = styled(ErrorMessage)`
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0.0025em;
    margin: 0;
    color: #d55961;
    padding-left: 20px;
    position: absolute;
    bottom: 14px;
    right: 10px;

    :before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        width: 12px;
        height: 12px;
        background-image: url('/svg/warning-circle.svg');
        background-repeat: no-repeat;
        background-position: center center;
        border-radius: 12px;
        background-size: 12px;
        transform: translate(0, -50%);
    }
`

export const InputStyle = css`
    font-family: ${Variables.font.body};
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    padding: 18px 10px 14px 0px;
    height: 50px;
    border: none;
    border-bottom: 1px solid ${Variables.color.white};
    border-radius: 0;
    outline: none;
    background: none;
    box-sizing: border-box;
    -webkit-appearance: none;

    ${media('>=desktop')} {
        box-sizing: border-box;
        border-radius: 0;
        font-size: 18px;
        line-height: 22px;
        color: ${Variables.color.white};
        height: 50px;
    }

    ::placeholder {
        color: white;
    }

    :-webkit-autofill {
        -webkit-box-shadow: 0 0 0 50px ${Variables.color.primary} inset;
        -webkit-text-fill-color: #ffffff;
    }

    :focus {
        border-color: white;
    }
`

export const Input = styled(Field)`
    color: ${Variables.color.white};
    ${InputStyle}
`

export const Textarea = styled(Field)`
    ${InputStyle}
    background-color: ${Variables.color.white};
    color: ${Variables.color.pazola} !important;
    min-height: 169px;
    padding: 18px 10px 14px 16px;

    ${media('<desktop')} {
        padding: 24px 21px;
    }

    ::placeholder {
        color: ${Variables.color.pazola};
    }

    :focus {
        border-color: ${Variables.color.pazola};
    }
`

export const StyledSelect = styled(Field)`
    ${InputStyle}
    color: ${Variables.color.white};
    background-position: 96% 22px;
    background-repeat: no-repeat;
    cursor: pointer;

    ${media('>=desktop')} {
        background-position: 98% 20px;
    }

    option {
        color: #000000;
    }

    :disabled {
        opacity: 1;
    }

    + ${ValidationError} {
        right: 33px;
    }
`

export const Select = ({ children, ...props }) => {
    return <StyledSelect {...props}>{children}</StyledSelect>
}

export const InputRow = styled.div`
    width: 100%;
    display: flex;
    margin: 15px 0;
    margin-bottom: 19px;
    box-sizing: border-box;
    flex-wrap: wrap;
    position: relative;

    ${media('<desktop')} {
        margin-bottom: 19px;
    }

    ${StyledSelect}, ${Input}, ${Textarea} {
        width: 100%;
    }

    ${Textarea} {
        ${media('<desktop')} {
            min-height: 140px;
        }
    }

    ${CheckboxContainer} {
        ${media('<desktop')} {
            margin-top: 10px;
        }
    }

    &:first-child {
        ${media('>=desktop')} {
            margin-top: 0;
        }
    }

    // Group field
    ${(props) =>
        props.group &&
        css`
            border-radius: 0;
            flex-wrap: nowrap;
        `}

    // Validation error
    ${(props) =>
        props.error &&
        css`
            border-color: ${Variables.color.red};
            ${StyledSelect}, ${Input}, ${Textarea} {
                border-color: ${Variables.color.red};
            }
        `}
`
